import { useNode } from '@craftjs/core';
import { useCallback } from 'react';
import {
  AnswersPanel,
  LayoutPanel,
  LogicPanel,
  SliderInputPanel,
  TitlePanel,
  ValidationPanel,
} from 'src/features/generalForms/builder/layout/panels';
import { FormSliderInputComponent, SliderInputProps } from 'src/features/generalForms/builder/types/SliderInput';
import { useDataKeyValidation } from 'src/features/generalForms/builder/validationContext/helper';
import { AppSliderField } from 'src/features/generalForms/uikit/fields/slider/sliderField';
import { SliderColorSchemeEnum } from 'uikit/inputs/slider/appSliderInput';

export const FormSliderInput: FormSliderInputComponent = (props) => {
  const {
    actions: { setProp },
    connectors: { connect, drag },
    styles,
  } = useNode((node) => ({
    linkedNodes: node.data.linkedNodes,
    styles: node.data.custom,
  }));

  const validationResult = useDataKeyValidation();

  const setScalarValue = useCallback(
    (newValue: number | undefined) => {
      setProp((p: SliderInputProps) => {
        p.defaultValue = newValue?.toString();
      });
    },
    [setProp],
  );

  return (
    <div ref={(ref: HTMLDivElement) => connect(drag(ref))} style={styles}>
      <AppSliderField
        showMarks={!props.hideMarks}
        startWith={props.minValue ?? 0}
        endWith={props.maxValue ?? 10}
        step={props.step}
        marksStep={props.marksStep}
        startPoint={props.startPoint}
        caption={{
          startText: props.captionStartText,
          centerText: props.captionCenterText,
          endText: props.captionEndText,
        }}
        labelProps={{
          text: props.title,
          isBold: true,
          tooltip: props.tooltip,
          description: props.description,
          isOptional: props.isOptional,
          prefix: props.prefix,
        }}
        disabled={props.disabled}
        value={props.defaultValue}
        colorScheme={props.colorScheme ?? SliderColorSchemeEnum.SingleColor}
        onChange={setScalarValue}
        showNumberInput={props.showNumberInput}
        errorProps={{ errors: validationResult?.message }}
      />
    </div>
  );
};

const FormSliderInputSettings = () => (
  <>
    <TitlePanel sections={['Title', 'Description', 'Prefix', 'Tooltip', 'DataKey']} />
    <AnswersPanel sections={['NoAnswerScore']} />
    <SliderInputPanel />
    <LayoutPanel sections={['Paddings']} />
    <ValidationPanel />
    <LogicPanel sections={['Visible', 'Enable']} />
  </>
);

FormSliderInput.craft = {
  displayName: 'Slider',
  rules: {
    canDrag: () => true,
  },
  related: {
    settings: FormSliderInputSettings,
  },
};
